import PropTypes from 'prop-types';
import React from 'react';

import { formatCurrencyNumber } from '../../lib/numberFormatter';

const IneligibleLoanAmountScreen = ({
  currency,
  scholarshipPeriodAmount,
  sponsorshipPeriodAmount,
  loansPeriodAmount,
  handleClick,
}) => {
  const { REACT_APP_PLATFORM_DASHBOARD: PLATFORM_DASHBOARD_URL } = process.env;

  return (
    <div>
      <div className="row-spacer">
        <div className="row-spacer">
          <div className="row">
            <div className="col col--12/16-small">
              The loan amount you qualify for is dependent on the course and the funds that you have
              declared as detailed below:
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col col--6/16-small">
            <div className="loan-amount-breakdown__list">
              <ul>
                <li>
                  <div className="loan-amount-breakdown__list__label">Confirmed scholarships</div>
                  <div className="value">
                    {currency}&nbsp;
                    <span>{formatCurrencyNumber(scholarshipPeriodAmount) || 0}</span>
                  </div>
                </li>
                <li>
                  <div className="loan-amount-breakdown__list__label">Company sponsorship</div>
                  <div className="value">
                    {currency}&nbsp;
                    <span>{formatCurrencyNumber(sponsorshipPeriodAmount) || 0}</span>
                  </div>
                </li>
                <li>
                  <div className="loan-amount-breakdown__list__label">Other loans</div>
                  <div className="value">
                    {currency}&nbsp;
                    <span>{formatCurrencyNumber(loansPeriodAmount) || 0}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row-spacer">
        <div className="row">
          <div className="col col--12/16-small">
            If the above values are incorrect, please edit your funding sources on the previous
            pages. Supporting documents will be asked to verify these values and any inaccuracies
            may result in withdrawal or change of any loan offer.
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col col--auto">
          <a href={`${PLATFORM_DASHBOARD_URL}`} className="link-button link-button--inverted">
            Go to dashboard
          </a>
        </div>
        <div className="col col--auto">
          <a href="/" className="link-button" onClick={handleClick}>
            Back to funds
          </a>
        </div>
      </div>
    </div>
  );
};

IneligibleLoanAmountScreen.propTypes = {
  currency: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  scholarshipPeriodAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sponsorshipPeriodAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loansPeriodAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default IneligibleLoanAmountScreen;
